import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('hs_admin_user') || 'null'),
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      localStorage.setItem('hs_admin_user', JSON.stringify(user));
    },
    logout(state) {
      state.user = null;
      localStorage.removeItem('hs_admin_token');
      localStorage.removeItem('hs_admin_user');
    },
  },
});
